var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-modal",
        {
          attrs: { title: "地址管理", width: "600px" },
          model: {
            value: _vm.isModalVisible,
            callback: function ($$v) {
              _vm.isModalVisible = $$v
            },
            expression: "isModalVisible",
          },
        },
        [
          _c(
            "a-form-model",
            {
              ref: "addressForm",
              attrs: {
                model: _vm.currentAddress,
                rules: _vm.rules,
                layout: "horizontal",
              },
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "收货人",
                            prop: "recipientName",
                            "label-col": { span: 5 },
                            "wrapper-col": { span: 19 },
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入收货人" },
                            model: {
                              value: _vm.currentAddress.recipientName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.currentAddress,
                                  "recipientName",
                                  $$v
                                )
                              },
                              expression: "currentAddress.recipientName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "电话",
                            prop: "contactPhone",
                            "label-col": { span: 5 },
                            "wrapper-col": { span: 19 },
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入电话" },
                            model: {
                              value: _vm.currentAddress.contactPhone,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.currentAddress,
                                  "contactPhone",
                                  $$v
                                )
                              },
                              expression: "currentAddress.contactPhone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "详细地址",
                            prop: "detailedAddress",
                            "label-col": { span: 5 },
                            "wrapper-col": { span: 19 },
                          },
                        },
                        [
                          _c("a-textarea", {
                            attrs: { placeholder: "请输入详细地址" },
                            model: {
                              value: _vm.currentAddress.detailedAddress,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.currentAddress,
                                  "detailedAddress",
                                  $$v
                                )
                              },
                              expression: "currentAddress.detailedAddress",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "a-button",
                {
                  key: "submit",
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handleOk },
                },
                [_vm._v(" 提交 ")]
              ),
              _c("a-button", { key: "back", on: { click: _vm.handleCancel } }, [
                _vm._v(" 取消 "),
              ]),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }